import { axiosMock } from '@api/client';
import { API_URL } from '@api/apiDictionary';
import { faker } from '@faker-js/faker';
import { QcStatusEnum } from '@dynamika-shared/types/status';

export const randomQCTask = () => ({
  id: faker.string.uuid(),
  assigneeId: faker.string.uuid(),
  assigneeName: faker.person.fullName(),
  patientCode: faker.helpers.mustache('{{letters}}-{{numbers}}', {
    letters: () => `${faker.string.alpha({ length: 3, casing: 'upper' })}`,
    numbers: () => `${faker.string.numeric({ length: 3 })}`,
  }),
  visitDefinitionId: faker.string.uuid(),
  latestUpload: faker.date.past().toISOString(),
  siteId: faker.string.uuid(),
  labels: Array.from({ length: 10 }, faker.word.noun),
  status: faker.string.fromCharacters(Object.values(QcStatusEnum)),
});

export const fetchQCTaskMock = async (siteId: string) => {
  const data = randomQCTask();

  axiosMock.onGet(API_URL.qcTasks).reply(200, data);
  axiosMock.onGet(API_URL.qcTasks, {
    params: {
      siteId,
    },
  });
};
